import React, {useState, useEffect} from "react";
import "../components/Blog.css";
import { useLocation } from "react-router-dom";

const BlogDetails = () => {
  const location = useLocation();

  const [otherblogs, setOtherBlogs] = useState([]);

  // Fetch Blogs
  const fetchBlogs = async () => {
    try {
      const res = await fetch("reactapi/api/codeinputs/get_otherblogs", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ url: location.pathname }),
      });
      const data = await res.json();
      setOtherBlogs(data.html || []);
      console.log(otherblogs.length);
    } catch (err) {
      console.error(err);
    }
  };

  // color picker tool
  const[hex,setHex] = useState('#3498db');

  const hexToRgba = (hex) => {
    let r = 0,g = 0,b = 0;

    if(hex.length === 4)
    {
      r = parseInt(hex[1]+hex[1],16);
      g = parseInt(hex[2]+ hex[2],16);
      b = parseInt(hex[3] + hex[3], 16);
    }
    else if(hex.length === 7)
    {
      r = parseInt(hex.slice(1, 3), 16);
          g = parseInt(hex.slice(3, 5), 16);
          b = parseInt(hex.slice(5, 7), 16);
    }

    return `rgba(${r}, ${g}, ${b}, 1)`;
  };

  const hexToRgb = (hex) => {
    let r = 0,g = 0,b = 0;

    if(hex.length === 4)
    {
      r = parseInt(hex[1]+hex[1],16);
      g = parseInt(hex[2]+ hex[2],16);
      b = parseInt(hex[3] + hex[3], 16);
    }
    else if(hex.length === 7)
    {
      r = parseInt(hex.slice(1, 3), 16);
          g = parseInt(hex.slice(3, 5), 16);
          b = parseInt(hex.slice(5, 7), 16);
    }

    return `rgb(${r}, ${g}, ${b})`;
  };

  useEffect(() => {
    fetchBlogs();
  }, []);
  return (
    <>
      {/* BLOG HERO */}
      <section className="blog-hero">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <h1>
                Color Picker Tool
              </h1>
              <p>
                Published by <strong>Code Inputs</strong> • Complete Guide
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* BLOG CONTENT */}
      <section className="blog-wrapper">
        <div className="container">
          <div className="row">

            {/* BLOG MAIN CONTENT */}
            <div className="col-lg-8">
              <div className="blog-card">

              
      <p>Color Code Finder is your ultimate tool for selecting, identifying, and copying color codes in a fast, intuitive, and efficient way. Whether you're a web developer, graphic designer, digital artist, or just someone who loves working with color, this tool makes it incredibly easy to pick a color and instantly see its values in multiple formats including HEX, RGB, and RGBA.</p>
          <h5>Choose Color</h5>
          <input
              type="color"
              value={hex}
              onChange={(e) => setHex(e.target.value)}
              className="color-input"
          />
          <div className="color-values">
            <p><strong>HEX:</strong> {hex}</p>
            <p><strong>RGBA:</strong> {hexToRgba(hex)}</p>
            <p><strong>RGB:</strong> {hexToRgb(hex)}</p>
          </div>
          </div>
        </div>

             {/* SIDEBAR */}
            <div className="col-lg-4">
              <div className="blog-sidebar">

                <div className="sidebar-card">
                  <h4 className="sidebar-title">Other Blogs</h4>

                    {otherblogs.length === 0 ? (
                    <p className="text-muted">No blogs found</p>
                  ) : (
                    otherblogs.map((item, index) => (
                      <a
                        href={`/${item.route}`}
                        className="other-blog"
                        key={index}
                      >
                        <img
                          src={`/graphics/images/${item.image}`}
                          alt={item.title}
                        />
                        <div>
                          <h6>{item.title}</h6>
                          <span>
                            {Math.floor(Math.random() * 10) + 1} min read
                          </span>
                        </div>
                      </a>
                    ))
                  )}

                </div>

                <div className="sidebar-card text-center">
                  <h5 className="mb-2">Need Custom Software?</h5>
                  <p className="small text-muted mb-3">
                    Let’s build something amazing together.
                  </p>
                  <a href="/contact" className="btn btn-primary w-100">
                    Contact Us
                  </a>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default BlogDetails;
